/* Aitak theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  var A = window.Aitak || { routes: { cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', checkout: '/checkout' }, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------------ toast */
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'), m = $('#toastMsg');
    if (!t || !m) return;
    m.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------------------------------------------------------------- overlays */
  function drawerEl() { return $('[data-cart-drawer]'); }
  function menuEl() { return $('[data-mobile-menu]'); }
  function qvOverlayEl() { return $('#qvOverlay'); }

  function syncOverlay() {
    var d = drawerEl(), m = menuEl(), q = qvOverlayEl();
    var open = (d && d.classList.contains('open')) || (m && m.classList.contains('open')) || (q && q.classList.contains('open'));
    var o = $('#overlay');
    if (o) o.classList.toggle('open', !!open);
    document.body.classList.toggle('no-scroll', !!open);
  }

  function openDrawer() {
    var d = drawerEl(); if (!d) return;
    closeQuickView(true);
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    syncOverlay();
  }
  function closeDrawer() {
    var d = drawerEl(); if (!d) return;
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true');
    syncOverlay();
  }
  function openMenu() { var m = menuEl(); if (m) { m.classList.add('open'); m.setAttribute('aria-hidden', 'false'); syncOverlay(); } }
  function closeMenu() { var m = menuEl(); if (m) { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); syncOverlay(); } }
  function closeAll() { closeDrawer(); closeMenu(); closeQuickView(); }

  /* -------------------------------------------------------------------- cart */
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }

  function applyCartSections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = $('[data-cart-drawer]', doc), cur = drawerEl();
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      cur.setAttribute('data-item-count', fresh.getAttribute('data-item-count'));
      setCount(fresh.getAttribute('data-item-count'));
    }
  }

  function jsonFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) { throw new Error(data.description || data.message || A.strings.error || 'Error'); }
        return data;
      });
    });
  }

  function addToCart(items) {
    return jsonFetch(A.routes.cartAdd, { items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
      .then(function (data) { applyCartSections(data.sections); return data; });
  }

  function changeLine(line, quantity) {
    return jsonFetch(A.routes.cartChange, { line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      .then(function (data) {
        applyCartSections(data.sections);
        setCount(data.item_count);
        if (A.template === 'cart') { window.location.reload(); }
        return data;
      });
  }

  function afterAdd() {
    toast(A.strings.added || 'Added to your bag');
    if (A.cartDrawer === 'drawer') { openDrawer(); }
  }

  /* -------------------------------------------------------------- quick view */
  function openQuickView(url) {
    var modal = $('#qvModal'), ov = qvOverlayEl();
    if (!modal || !ov) { window.location.href = url; return; }
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', 'quick-view');
    modal.innerHTML = '<div class="qv-loading">Loading…</div>';
    ov.classList.add('open'); ov.setAttribute('aria-hidden', 'false'); ov.scrollTop = 0;
    syncOverlay();
    fetch(u.toString()).then(function (r) { if (!r.ok) throw new Error('qv'); return r.text(); })
      .then(function (html) { modal.innerHTML = html; markWishlist(); })
      .catch(function () { window.location.href = url; });
  }
  function closeQuickView(silent) {
    var ov = qvOverlayEl(); if (!ov) return;
    ov.classList.remove('open'); ov.setAttribute('aria-hidden', 'true');
    if (!silent) syncOverlay();
  }

  /* --------------------------------------------------------- product / variant */
  function variantsOf(root) {
    if (root._variants) return root._variants;
    var s = $('script[data-variants]', root);
    try { root._variants = s ? JSON.parse(s.textContent) : null; } catch (e) { root._variants = null; }
    return root._variants;
  }
  function selectedOptions(root) {
    return $$('[data-option-group]', root).map(function (g) {
      var s = $('.size-pill.selected', g); return s ? s.getAttribute('data-value') : null;
    });
  }
  function setHidden(el, hide) { if (el) { if (hide) el.setAttribute('hidden', ''); else el.removeAttribute('hidden'); } }

  function updateVariant(root) {
    var variants = variantsOf(root); if (!variants) return;
    var sel = selectedOptions(root);
    var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
    var addBtn = $('[data-add-btn]', root), buyBtn = $('[data-buy-now]', root), label = $('[data-add-label]', root);
    var avail = $('[data-avail]', root), availText = $('[data-avail-text]', root);

    if (!v) {
      if (label) label.textContent = A.strings.unavailable || 'Unavailable';
      if (addBtn) addBtn.disabled = true; if (buyBtn) buyBtn.disabled = true;
      if (avail) avail.classList.add('out'); if (availText) availText.textContent = A.strings.unavailable || 'Unavailable';
      return;
    }
    $('[data-variant-input]', root).value = v.id;
    $('[data-price]', root).textContent = v.price;
    var cmp = $('[data-compare]', root), save = $('[data-save]', root);
    if (cmp) { cmp.textContent = v.compare || ''; setHidden(cmp, !v.compare); }
    if (save) { save.textContent = v.save ? 'Save ' + v.save : ''; setHidden(save, !v.save); }
    var sku = $('[data-sku]', root);
    if (sku) { sku.textContent = v.sku ? 'SKU: ' + v.sku : ''; setHidden(sku, !v.sku); }
    if (avail) avail.classList.toggle('out', !v.available);
    if (availText) availText.textContent = v.available ? (A.strings.inStock || 'In stock') : (A.strings.soldOut || 'Sold out');
    if (label) label.textContent = v.available ? (A.strings.addToCart || 'Add to Cart') : (A.strings.soldOut || 'Sold out');
    if (addBtn) addBtn.disabled = !v.available;
    if (buyBtn) buyBtn.disabled = !v.available;

    if (v.image) {
      var main = $('[data-main-image]', root);
      if (main) { main.src = v.image; main.removeAttribute('srcset'); }
      $$('.qv-thumb', root).forEach(function (t) { t.classList.toggle('selected', t.getAttribute('data-src') === v.image); });
    }
    if (root.getAttribute('data-update-url') === 'true' && window.history && history.replaceState) {
      history.replaceState(null, '', window.location.pathname + '?variant=' + v.id);
    }
  }

  function submitProduct(form, buyNow) {
    var root = form.closest('[data-product-root]') || form;
    var id = parseInt($('[data-variant-input]', form).value, 10);
    var qty = parseInt($('[data-qty-input]', form).value, 10) || 1;
    var err = $('[data-form-error]', form);
    var btn = buyNow ? $('[data-buy-now]', form) : $('[data-add-btn]', form);
    if (err) setHidden(err, true);
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }
    addToCart([{ id: id, quantity: qty }]).then(function () {
      if (buyNow) { window.location.href = A.routes.checkout; return; }
      closeQuickView(true);
      afterAdd();
    }).catch(function (e) {
      if (err) { err.textContent = e.message; setHidden(err, false); } else { toast(e.message); }
    }).then(function () {
      if (btn && !buyNow) { btn.disabled = false; }
      if (btn) { btn.classList.remove('loading'); }
      if (buyNow && btn) { btn.disabled = false; }
      updateVariant(root);
    });
  }

  /* ---------------------------------------------------------------- wishlist */
  var WL_KEY = 'aitak_wishlist';
  function readWL() { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; } }
  function writeWL(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }
  function markWishlist() {
    var list = readWL();
    $$('[data-wishlist]').forEach(function (b) { b.classList.toggle('on', list.indexOf(b.getAttribute('data-handle')) > -1); });
  }
  function toggleWishlist(btn) {
    var h = btn.getAttribute('data-handle'), list = readWL(), i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); } else { list.push(h); toast('Added to wishlist'); }
    writeWL(list); markWishlist();
  }

  /* ------------------------------------------------------------ page widgets */
  function initRecommendations() {
    var box = $('[data-recommendations]');
    if (!box || box._loaded) return; box._loaded = true;
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = $('.qv-related-inner', doc);
      if (inner && inner.innerHTML.trim()) { box.innerHTML = inner.innerHTML; box.removeAttribute('hidden'); }
    }).catch(function () {});
  }

  function initHelpToc() {
    var toc = $('[data-help-toc]'); if (!toc || toc._init) return; toc._init = true;
    var links = $$('a', toc), blocks = $$('.policy-block');
    links.forEach(function (l) {
      l.addEventListener('click', function (e) {
        var t = $(l.getAttribute('href'));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
    window.addEventListener('scroll', function () {
      var cur = blocks[0] && blocks[0].id;
      blocks.forEach(function (b) { if (window.scrollY + 130 >= b.offsetTop) cur = b.id; });
      links.forEach(function (l) { l.classList.toggle('active', l.getAttribute('href') === '#' + cur); });
    }, { passive: true });
  }

  function initMobileMenu() {
    $$('body > [data-mobile-menu]').forEach(function (el) { el.remove(); });
    var m = $('[data-mobile-menu]');
    if (m && m.parentNode !== document.body) document.body.appendChild(m);
  }

  /* ----------------------------------------------------------- click routing */
  document.addEventListener('click', function (e) {
    var t = e.target;
    function hit(sel) { return t.closest ? t.closest(sel) : null; }
    var el;

    /* whole product card -> product page (taps on buttons/links keep their own action) */
    if ((el = hit('[data-product-card]')) && !hit('a, button, input, select, textarea, label, form')) {
      var pl = $('.pname-link', el) || $('.thumb-link', el);
      if (pl && pl.href) { window.location.href = pl.href; return; }
    }

    if ((el = hit('[data-cart-open]'))) {
      if (A.cartDrawer === 'drawer' && A.template !== 'cart' && drawerEl()) { e.preventDefault(); openDrawer(); }
      return;
    }
    if (hit('[data-cart-close]') || hit('[data-menu-close]') || t.id === 'overlay') { e.preventDefault(); closeAll(); return; }
    if (hit('[data-menu-open]')) { openMenu(); return; }
    if (hit('[data-mobile-search-toggle]')) {
      e.preventDefault();
      var bar = $('#mobileSearchBar');
      if (bar) { var o = bar.classList.toggle('open'); if (o) { var i = $('input', bar); if (i) setTimeout(function () { i.focus(); }, 150); } }
      return;
    }
    if ((el = hit('[data-cart-qty]'))) {
      e.preventDefault();
      el.disabled = true;
      changeLine(parseInt(el.getAttribute('data-line'), 10), parseInt(el.getAttribute('data-cart-qty'), 10))
        .catch(function (err) { toast(err.message); }).then(function () { el.disabled = false; });
      return;
    }
    if ((el = hit('[data-quick-add]'))) {
      e.preventDefault(); e.stopPropagation();
      if (el.getAttribute('data-single') === 'true') {
        el.disabled = true;
        addToCart([{ id: parseInt(el.getAttribute('data-variant-id'), 10), quantity: 1 }])
          .then(afterAdd).catch(function (err) { toast(err.message); }).then(function () { el.disabled = false; });
      } else {
        openQuickView(el.getAttribute('data-url'));
      }
      return;
    }
    if (hit('[data-qv-close]') || t === qvOverlayEl()) { closeQuickView(); return; }
    if ((el = hit('[data-wishlist]'))) { e.preventDefault(); e.stopPropagation(); toggleWishlist(el); return; }

    if ((el = hit('.size-pill'))) {
      var group = el.parentNode;
      $$('.size-pill', group).forEach(function (p) { p.classList.remove('selected'); p.setAttribute('aria-checked', 'false'); });
      el.classList.add('selected'); el.setAttribute('aria-checked', 'true');
      var root = el.closest('[data-product-root]'); if (root) updateVariant(root);
      return;
    }
    if ((el = hit('.qv-thumb'))) {
      var r = el.closest('[data-product-root]'), main = r && $('[data-main-image]', r);
      if (main) { main.src = el.getAttribute('data-src'); main.removeAttribute('srcset'); }
      $$('.qv-thumb', r).forEach(function (x) { x.classList.remove('selected'); });
      el.classList.add('selected');
      return;
    }
    if ((el = hit('.qv-tab-btn'))) {
      var tabs = el.closest('.qv-tabs'), name = el.getAttribute('data-tab');
      $$('.qv-tab-btn', tabs).forEach(function (b) { b.classList.toggle('active', b === el); });
      $$('.qv-tab-panel', tabs).forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-panel') === name); });
      return;
    }
    if ((el = hit('[data-qty-step]'))) {
      var form = el.closest('form'), inp = $('[data-qty-input]', form), disp = $('[data-qty-display]', form);
      var v = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(el.getAttribute('data-qty-step'), 10));
      inp.value = v; disp.textContent = v;
      return;
    }
    if ((el = hit('[data-buy-now]'))) {
      e.preventDefault(); submitProduct(el.closest('form'), true); return;
    }
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches && f.matches('[data-product-form]')) { e.preventDefault(); submitProduct(f, false); }
  });

  document.addEventListener('change', function (e) {
    var f = e.target.closest && e.target.closest('form[data-auto-submit]');
    if (!f) return;
    $$('input[type="number"]', f).forEach(function (i) { if (!i.value) i.disabled = true; });
    f.submit();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* -------------------------------------------------------------------- init */
  function init() {
    initRecommendations();
    initHelpToc();
    initMobileMenu();
    markWishlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', init);
})();
